export interface UserState {
  id: string;
  fullName: string;
  email: string;
}

const initialState: UserState = {
  id: '',
  fullName: 'System',
  email: '',
};

export default function userReducer(state = initialState, action: any): UserState {
  switch (action.type) {
    case 'SET_USER':
      return {
        id: action.payload.sub || '',
        fullName: action.payload.name || '',
        email: action.payload.email || '',
      };
    case 'CLEAR_USER':
      return initialState;
    default:
      return state;
  }
}
